<template>
    <div id="tabs">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link pre-tax-cashflow active" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true"><span class="tab-label text-success" v-bind:class="{'text-danger': (weeklyPreExpensesBiggerThanIncome && weekly) || (annualPreExpensesBiggerThanIncome && annual)}" style="display: block;">Pre-tax <span style="white-space:nowrap;">Cashflow <span ref="tooltip-id-one" @mouseover="showTooltipOne" @mouseleave="hideTooltipOne" class="label-tooltip rounded-circle">?<span v-show="activeTooltipOne" class="calc-tooltip">{{ tooltipText('Pre-tax Cashflow') }}<div class="arrow-down"></div></span></span></span><span class="tab-value" style="display: block;"><span v-show="weekly" class="text-success" v-bind:class="{'text-danger': weeklyPreExpensesBiggerThanIncome}">{{ weeklyPreCashflowEstimateValue }}</span><span v-show="annual" class="text-success" v-bind:class="{'text-danger': annualPreExpensesBiggerThanIncome}">{{ annualPreCashflowEstimateValue }}</span></span></span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link post-tax-cashflow" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"><span class="tab-label text-success" v-bind:class="{'text-danger': (weeklyPostExpensesBiggerThanIncome && weekly) || (annualPostExpensesBiggerThanIncome && annual)}" style="display: block;">Post-tax <span style="white-space:nowrap;">Cashflow <span ref="tooltip-id-two" @mouseover="showTooltipTwo" @mouseleave="hideTooltipTwo" class="label-tooltip rounded-circle">?<span v-show="activeTooltipTwo" class="calc-tooltip">{{ tooltipText('Post-tax Cashflow') }}<div class="arrow-down"></div></span></span></span><span class="tab-value" style="display: block;"><span v-show="weekly" class="text-success" v-bind:class="{'text-danger': weeklyPostExpensesBiggerThanIncome}">{{ weeklyPostCashflowEstimateValue }}</span><span v-show="annual" class="text-success" v-bind:class="{'text-danger': annualPostExpensesBiggerThanIncome}">{{ annualPostCashflowEstimateValue }}</span></span></span></a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <p v-show="weekly" class="weekly-breakdown">Weekly Breakdown</p>
                <ul v-show="weekly" class="leaders">
                    <li class="text-success"><span>Rental Income</span> <span>{{ weeklyRentalIncomeValue }}</span></li>
                    <li class="text-danger"><span>Weekly Expenses</span> <span class="interest-on-loan-value"><span v-show="weeklyPreTotalExpensesValue != 0" class="minus">-</span>{{ weeklyPreTotalExpensesValue }}</span></li>
                </ul>
                <div v-show="weekly" class="label-value weekly-cashflow text-success" v-bind:class="{'text-danger': weeklyPreExpensesBiggerThanIncome}">
                    <p class="weekly-cashflow-value">Weekly Cashflow.....{{ weeklyPreCashflowEstimateValue }}</p>
                </div>

                <p v-show="annual" class="annual-breakdown">Annual Breakdown</p>
                <ul v-show="annual" class="leaders">
                    <li class="text-success"><span>Rental Income</span> <span>{{ annualRentalIncomeValue }}</span></li>
                    <li class="text-danger"><span>Annual Expenses</span> <span class="interest-on-loan-value"><span v-show="annualPreTotalExpensesValue != 0" class="minus">-</span>{{ annualPreTotalExpensesValue }}</span></li>
                </ul>
                <div v-show="annual" class="label-value annual-cashflow text-success" v-bind:class="{'text-danger': annualPreExpensesBiggerThanIncome}">
                    <p class="annual-cashflow-value">Annual Cashflow.....{{ annualPreCashflowEstimateValue }}</p>
                </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <p v-show="weekly" class="weekly-breakdown">Weekly Breakdown</p>
                <ul style="margin-bottom: 0;" v-show="weekly" class="leaders">
                    <li class="text-success"><span>Rental Income</span> <span>{{ weeklyRentalIncomeValue }}</span></li>
                    <li class="text-danger"><span>Total Deductible Expenses</span> <span><span v-show="weeklyPostTotalClaimableExpensesValue != 0" class="minus">-</span>{{ weeklyPostTotalClaimableExpensesValue }}</span></li>
                    <li class="text-danger"><span>Depreciation + LMI Portion</span> <span class="net-taxable-amount-value"><span v-show="weeklyPostDeprecationValue != 0" class="minus">-</span>{{ weeklyPostDeprecationValue }}</span></li>
                    <li class="text-success net-taxable-amount" v-bind:class="{'text-danger': weeklyNetTaxableAmountNegative}"><span>Net Taxable Amount</span> <span>{{ weeklyPostNetTaxableAmountValue }}</span></li>
                    <li class="text-success" v-bind:class="{'text-danger': !weeklyNetTaxableAmountNegative}"><span>Tax Rebate (or Payable)</span> <span>{{ weeklyPostTaxRebateValue }}</span></li>
                    <li class="text-success" v-bind:class="{'text-danger': weeklyPreExpensesBiggerThanIncome}"><span style="font-style: oblique;">Plus Pre-tax Cashflow</span> <span class="interest-on-loan-value">{{ weeklyPreCashflowEstimateValue }}</span></li>
                </ul>
                <div style="margin-top: 0;" v-show="weekly" class="label-value weekly-cashflow text-success" v-bind:class="{'text-danger': weeklyPostExpensesBiggerThanIncome}">
                    <p class="weekly-cashflow-value">{{ weeklyPostCashflowEstimateValue }}</p>
                </div>

                <p v-show="annual" class="annual-breakdown">Annual Breakdown</p>
                <ul style="margin-bottom: 0;" v-show="annual" class="leaders">
                    <li class="text-success"><span>Rental Income</span> <span>{{ annualRentalIncomeValue }}</span></li>
                    <li class="text-danger"><span>Total Deductible Expenses</span> <span><span v-show="annualPostTotalClaimableExpensesValue != 0" class="minus">-</span>{{ annualPostTotalClaimableExpensesValue }}</span></li>
                    <li class="text-danger"><span>Depreciation + LMI Portion</span> <span class="net-taxable-amount-value"><span v-show="annualPostDeprecationValue != 0" class="minus">-</span>{{ annualPostDeprecationValue }}</span></li>
                    <li class="text-success net-taxable-amount" v-bind:class="{'text-danger': annualNetTaxableAmountNegative}"><span>Net Taxable Amount</span> <span>{{ annualPostNetTaxableAmountValue }}</span></li>
                    <li class="text-success" v-bind:class="{'text-danger': !annualNetTaxableAmountNegative}"><span>Tax Rebate (or Payable)</span> <span>{{ annualPostTaxRebateValue }}</span></li>
                    <li class="text-success" v-bind:class="{'text-danger': annualPreExpensesBiggerThanIncome}"><span style="font-style: oblique;">Plus Pre-tax Cashflow</span> <span class="interest-on-loan-value">{{ annualPreCashflowEstimateValue }}</span></li>
                </ul>
                <div style="margin-top: 0;" v-show="annual" class="label-value annual-cashflow text-success" v-bind:class="{'text-danger': annualPostExpensesBiggerThanIncome}">
                    <p class="annual-cashflow-value">{{ annualPostCashflowEstimateValue }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "tabs",
        data () {
            return {
                activeTooltipOne: false,
                activeTooltipTwo: false
            }
        },
        props: {
          weekly: Boolean,
          annual: Boolean
        },
        computed: {
            weeklyRentalIncomeValue() {
                return "$" + this.$store.state.results.getWeeklyRentalIncome().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPreTotalExpensesValue() {
                return "$" + this.$store.state.results.getWeeklyPreTotalExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPreCashflowEstimateValue() {
                var weeklyPreCashflowEstimate = this.$store.state.results.getWeeklyPreCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPreCashflowEstimate.includes('-')) {
                    weeklyPreCashflowEstimate = weeklyPreCashflowEstimate.slice(0, 1) + '$' + weeklyPreCashflowEstimate.slice(1, weeklyPreCashflowEstimate.length);
                } else {
                    weeklyPreCashflowEstimate = "$" + weeklyPreCashflowEstimate;
                }
                return weeklyPreCashflowEstimate;
            },
            weeklyPostTotalClaimableExpensesValue() {
                return "$" + this.$store.state.results.getWeeklyPostTotalClaimableExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPostDeprecationValue() {
                return "$" + this.$store.state.results.getWeeklyPostDeprecation().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPostNetTaxableAmountValue() {
                var weeklyPostNetTaxableAmount = this.$store.state.results.getWeeklyPostNetTaxableAmount().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostNetTaxableAmount.includes('-')) {
                    weeklyPostNetTaxableAmount = weeklyPostNetTaxableAmount.slice(0, 1) + '$' + weeklyPostNetTaxableAmount.slice(1, weeklyPostNetTaxableAmount.length);
                } else  {
                    weeklyPostNetTaxableAmount = "$" + weeklyPostNetTaxableAmount
                }
                return weeklyPostNetTaxableAmount;
            },
            weeklyPostTaxRebateValue() {
                var weeklyPostTaxRebate = this.$store.state.results.getWeeklyPostTaxRebate().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostTaxRebate.includes('-')) {
                    weeklyPostTaxRebate = weeklyPostTaxRebate.slice(0, 1) + '$' + weeklyPostTaxRebate.slice(1, weeklyPostTaxRebate.length);
                } else  {
                    weeklyPostTaxRebate = "$" + weeklyPostTaxRebate
                }
                return weeklyPostTaxRebate;
            },
            weeklyPostCashflowEstimateValue() {
                var weeklyPostCashflowEstimate = this.$store.state.results.getWeeklyPostCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostCashflowEstimate.includes('-')) {
                    weeklyPostCashflowEstimate = weeklyPostCashflowEstimate.slice(0, 1) + '$' + weeklyPostCashflowEstimate.slice(1, weeklyPostCashflowEstimate.length);
                } else  {
                    weeklyPostCashflowEstimate = "$" + weeklyPostCashflowEstimate
                }
                return weeklyPostCashflowEstimate;
            },
            annualRentalIncomeValue() {
                return "$" + this.$store.state.results.getAnnualRentalIncome().toLocaleString('en-US',{useGrouping:true});
            },
            annualPreTotalExpensesValue() {
                return "$" + this.$store.state.results.getAnnualPreTotalExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            annualPreCashflowEstimateValue() {
                var annualPreCashflowEstimate = this.$store.state.results.getAnnualPreCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (annualPreCashflowEstimate.includes('-')) {
                    annualPreCashflowEstimate = annualPreCashflowEstimate.slice(0, 1) + '$' + annualPreCashflowEstimate.slice(1, annualPreCashflowEstimate.length);
                } else  {
                    annualPreCashflowEstimate = "$" + annualPreCashflowEstimate
                }
                return annualPreCashflowEstimate;
            },
            annualPostTotalClaimableExpensesValue() {
                return "$" + this.$store.state.results.getAnnualPostTotalClaimableExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            annualPostDeprecationValue() {
                return "$" + this.$store.state.results.getAnnualPostDeprecation().toLocaleString('en-US',{useGrouping:true});
            },
            annualPostNetTaxableAmountValue() {
                var annualPostNetTaxableAmount = this.$store.state.results.getAnnualPostNetTaxableAmount().toLocaleString('en-US',{useGrouping:true});
                if (annualPostNetTaxableAmount.includes('-')) {
                    annualPostNetTaxableAmount = annualPostNetTaxableAmount.slice(0, 1) + '$' + annualPostNetTaxableAmount.slice(1, annualPostNetTaxableAmount.length);
                } else  {
                    annualPostNetTaxableAmount = "$" + annualPostNetTaxableAmount
                }
                return annualPostNetTaxableAmount;
            },
            annualPostTaxRebateValue() {
                var annualPostTaxRebate = this.$store.state.results.getAnnualPostTaxRebate().toLocaleString('en-US',{useGrouping:true});
                if (annualPostTaxRebate.includes('-')) {
                    annualPostTaxRebate = annualPostTaxRebate.slice(0, 1) + '$' + annualPostTaxRebate.slice(1, annualPostTaxRebate.length);
                } else  {
                    annualPostTaxRebate = "$" + annualPostTaxRebate
                }
                return annualPostTaxRebate;
            },
            annualPostCashflowEstimateValue() {
                var annualPostCashflowEstimate = this.$store.state.results.getAnnualPostCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (annualPostCashflowEstimate.includes('-')) {
                    annualPostCashflowEstimate = annualPostCashflowEstimate.slice(0, 1) + '$' + annualPostCashflowEstimate.slice(1, annualPostCashflowEstimate.length);
                } else  {
                    annualPostCashflowEstimate = "$" + annualPostCashflowEstimate
                }
                return annualPostCashflowEstimate;
            },
            weeklyPreExpensesBiggerThanIncome() {
                return this.$store.state.results.getWeeklyPreCashflowEstimate().toString().includes('-');
            },
            weeklyPostExpensesBiggerThanIncome() {
                return this.$store.state.results.getWeeklyPostCashflowEstimate().toString().includes('-');
            },
            annualPreExpensesBiggerThanIncome() {
                return this.$store.state.results.getAnnualPreCashflowEstimate().toString().includes('-');
            },
            annualPostExpensesBiggerThanIncome() {
                return this.$store.state.results.getAnnualPostCashflowEstimate().toString().includes('-');
            },
            weeklyNetTaxableAmountNegative() {
                return this.$store.state.results.getWeeklyPostNetTaxableAmount().toString().includes('-');
            },
            annualNetTaxableAmountNegative() {
                return this.$store.state.results.getAnnualPostNetTaxableAmount().toString().includes('-');
            }
        },
        methods: {
            showTooltipOne: function () {
                this.activeTooltipOne = true;
            },
            hideTooltipOne: function () {
                this.activeTooltipOne = false;
            },
            showTooltipTwo: function () {
                this.activeTooltipTwo = true;
            },
            hideTooltipTwo: function () {
                this.activeTooltipTwo = false;
            },
            tooltipText: function (tabTitle) {
                var helpText = "";

                switch (tabTitle) {
                    case 'Pre-tax Cashflow':
                        helpText = "Refers to the surplus or deficit of funds when expenses are subtracted from " +
                            "rental income. This figure is before any tax implications or rebate";
                        break;
                    case 'Post-tax Cashflow':
                        helpText = "Incorporates the tax-deductible items such as depreciation and other claimable " +
                            "items to create a net taxable position for the investment. Depending on the tax rate " +
                            "of the user they may be entitled to a tax rebate for these losses which when added to " +
                            "the pre-tax position creates a final post-tax cashflow. \n" +
                            "Please be aware that there are many factors that can influence your overall " +
                            "tax position and it is therefore highly recommended to seek advice from a " +
                            "qualified accountant or finance professional before making any investment decisions";
                        break;
                }

                return helpText;
            }
        },
        mounted() {

            let $vm = this;
            var tooltipOne = this.$refs['tooltip-id-one'];
            var tooltipTwo = this.$refs['tooltip-id-two'];
            tooltipOne.addEventListener('touchstart', function (e) {
                e.stopPropagation();
                $vm.activeTooltipOne = !$vm.activeTooltipOne;
            });
            tooltipTwo.addEventListener('touchstart', function (e) {
                e.stopPropagation();
                $vm.activeTooltipTwo = !$vm.activeTooltipTwo;
            });
        }
    }
</script>

<style scoped>

    ul.leaders {
        max-width: 60em;
        padding: 0;
        overflow-x: hidden;
        list-style: none;
        margin-left: 15px;
        margin-right: 15px;
    }

    ul.leaders li:before {
        float: left;
        width: 0;
        white-space: nowrap;
        content:
                ". . . . . . . . . . . . . . . . . . . . "
                ". . . . . . . . . . . . . . . . . . . . "
                ". . . . . . . . . . . . . . . . . . . . "
                ". . . . . . . . . . . . . . . . . . . . "
                ". . . . . . . . . . . . . . . . . . . . "
                ". . . . . . . . . . . . . . . . . . . . "
    }

    ul.leaders span:first-child {
        padding-right: 0.33em;
        background: white
    }

    ul.leaders span + span {
        float: right;
        padding-left: 0.33em;
        background: white
    }

    .minus {
        padding-right: 0 !important;
    }

    #tabs {
        width: 85%;
        margin: 0 auto;
        color: #465978;
    }

    .nav-tabs {
        width: 100%;
        margin-left: 0 !important;
    }

    .nav-item {
        width: 50%;
    }

    .nav-link {
        background-color: rgb(221, 221, 221);
        color: #465978;
        font-size: 20px;
        text-align: center;
        border-bottom-color: #465978;
        height: 100%;
        overflow: visible !important;
    }

    .nav-link.active {
        border: 1px solid #465978;
        color: #465978;
        font-weight: bold;
        border-bottom-color: #fff;
    }

     .active {
         border: 1px solid #465978;
         border-top-color: #fff;
         color: #465978;
         background-color: #fff;
         overflow: hidden;
     }

    .label-value {
        width: 100%;
        height: 20px;
        display: inline-block;
        overflow: hidden;
    }

    .annual-breakdown {
        font-weight: bold;
        font-size: 20px;
        margin-top: 15px;
        margin-left: 15px;
    }

    .weekly-breakdown {
        font-weight: bold;
        font-size: 20px;
        margin-top: 15px;
        margin-left: 15px;
    }

    .label-in-tab {
        float: left;
        margin-left: 15px;
        overflow: hidden;
        display: inline-block;
        white-space: nowrap;
    }

    .label-in-tab:after {
        content:
                ". . . . . . . . . . . . . . . . . . . . "
                ". . . . . . . . . . . . . . . . . . . . "
                ;
    }

    .value-in-tab {
        height: 20px;
        float: right;
        margin-right: 15px;
        overflow: hidden;
        text-align: right;
        display: inline;
        white-space: nowrap;
    }

    .dotted-space {
        border-bottom: 1px dotted;
        width: calc(100% - 245px);
        margin-bottom: 20px;
        display: inline-block;
    }

    .interest-on-loan {
        height: 30px;
    }

    .interest-on-loan-value {
        border-bottom: 6px double black;
        height: 30px;
    }

    .weekly-cashflow {
        max-width: 40em;
        display: inline-block;
        float: right;
        overflow: hidden;
        margin-right: 15px;
        margin-top: 15px;
        margin-bottom: 15px;
        font-weight: bold;
        height: 21px;
    }

    .weekly-cashflow-label {
        display: inline-block;
    }

    .weekly-cashflow-value {
        float: right;
        line-height: normal;
    }

    .annual-cashflow {
        width: 427px;
        display: inline-block;
        float: right;
        overflow: hidden;
        margin-right: 15px;
        margin-top: 15px;
        margin-bottom: 15px;
        font-weight: bold;
        height: 21px;
    }

    .annual-cashflow-label {
        width: 150px;
        display: inline-block;
    }

    .annual-cashflow-value {
        float: right;
        line-height: normal;
    }

    .net-taxable-amount {
        margin-bottom: 20px;
        margin-top: 2px;
    }

    .net-taxable-amount-value {
        border-bottom: 2px solid black;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .pre-tax-cashflow .calc-tooltip {
        top: -107px;
        height: 106px;
        width: 260px;
    }

    .post-tax-cashflow .calc-tooltip {
        top: -171px;
        height: 170px;
        width: 500px;
    }

    @media (min-width: 1537px) {
        .post-tax-cashflow .tab-label {
            width: 199px;
            margin-left: -2%;
        }
    }

    @media (min-width: 1274px) and (max-width: 1536px) {
        .tab-label {
            width: 147px;
            margin-left: 6%;
        }

        .post-tax-cashflow .calc-tooltip {
            top: -201px;
            height: 200px;
            width: 420px;
        }
    }

    @media (min-width: 1274px) and (max-width: 1404px) {
        .tab-value {
            margin-left: 5%;
        }
    }

    @media (min-width: 1024px) and (max-width: 1034px) {
        .tab-label {
            width: 112px;
        }
    }

    @media (min-width: 768px) and (max-width: 973px) {
        .pre-tax-cashflow .calc-tooltip {
            margin-left: -145%;
        }
        .pre-tax-cashflow .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 1023px) {
        .post-tax-cashflow .calc-tooltip {
            margin-left: -475%;
            left: -300px;
            width: 500px;
            height: 170px;
            top: -171px;
        }
        .post-tax-cashflow .arrow-down {
            margin-left: 387px;
        }
    }

    @media (max-width: 630px) {
        .post-tax-cashflow .calc-tooltip {
            left: -350px;
        }
        .post-tax-cashflow .arrow-down {
            margin-left: 437px;
        }
    }

    @media (max-width: 546px) {
        .post-tax-cashflow .calc-tooltip {
            left: -320px;
            width: 460px;
            height: 185px;
            top: -187px;
        }
        .post-tax-cashflow .arrow-down {
            margin-left: 407px;
        }
    }

    @media (min-width: 505px) and (max-width: 556px) {
        .post-tax-cashflow .tab-label {
            width: 199px;
            margin-left: -3%;
        }
    }

    @media (min-width: 505px) and (max-width: 516px) {
        .tab-label {
            width: 186px;
        }
    }

    @media (min-width: 493px) and (max-width: 505px) {
        .tab-label {
            width: 147px;
            margin-left: 5%;
        }
    }

    @media (max-width: 504px) {
        .post-tax-cashflow .calc-tooltip {
            margin-left: -475%;
            left: -180px;
            height: 228px;
            top: -229px;
            width: 340px;
            padding: 0;
        }
        .post-tax-cashflow .arrow-down {
            margin-left: 275px;
        }
    }

    @media (min-width: 428px) and (max-width: 492px) {
        .tab-label {
            width: 147px;
            margin-left: 5%;
        }
    }

    @media (min-width: 428px) and (max-width: 455px) {
        .tab-value {
            margin-left: 5%;
        }
    }

    @media (min-width: 475px) and (max-width: 492px) {
        .tab-value {
            margin-right: 5%;
        }
    }

    @media (max-width: 356px) {
        .post-tax-cashflow .calc-tooltip {
            margin-left: -475%;
            left: -150px;
            height: 258px;
            top: -259px;
            width: 300px;
            padding: 0;
        }
        .post-tax-cashflow .arrow-down {
            margin-left: 245px;
        }
    }

    @media print {
        .tab-content > .tab-pane {
            display: block !important;
            opacity: 1 !important;
            visibility: visible !important;
        }
    }

    @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0)
    { @media {
        .dotted-space {
            margin-bottom: 0;
        }
    }}

</style>


// WEBPACK FOOTER //
// src/Components/Tabs.vue